/**
 * ROUND8 - the dog team (docs/milestones/ROUND8-dogs.md, ROUND8-contracts.md). First guesses: the streams may
 * move any of them and say why. DOGSIM added `bayHold`, `castRadius` and `castSeconds`, and pinned down which way
 * round the two wind factors are (see `downwind`).
 */

export const DOGS = {
  /** It follows scent this old or younger, seconds (02 §9.1: "the last 60 s of your path"). */
  trailSeconds: 60,
  /** Nose down, looking for a trail, m/s; and running a hot one - faster than a sneak (1.3) or a crawl (0.9), slower than a run (4.6). */
  castSpeed: 1.5,
  trackSpeed: 3.2,
  /** It smells him outright within this, metres, on a still day - scaled by the two wind factors below. */
  noseRadius: 6,
  /**
   * The wind. Scent goes where the wind blows (`def.wind`, which pushes the pods too), so:
   * `downwind` - the DOG is downwind of him, the wind carrying his scent onto it: x1.5, it smells him at 9 m;
   * `upwind` - the dog is upwind of him, his scent carried away from it: x0.5, 3 m.
   * The standing order "STAY DOWNWIND" is the second case - he keeps downwind of the dog - and the HUD's arrow,
   * labelled DOWNWIND, points the way the wind blows (src/ui/hud/windArrow.ts). A crosswind is neither: the factor
   * slides between the two with the angle (specials/dogNose.ts).
   */
  downwind: 1.5,
  upwind: 0.5,
  /** It picks up a trail by passing this near a print, metres. */
  pickUpRadius: 2.5,
  /** Having him, it holds this far off and gives tongue, metres (it never bites: the owner, 2026-09-23). */
  bayDistance: 3,
  /**
   * Once it has him it keeps him out to `bayDistance` + this, metres, even where its nose alone would not reach:
   * a dog with the ranger 3 m upwind of it (a 3 m nose) would otherwise lose and find him again every step he took.
   * Water between them still ends it at once.
   */
  bayHold: 1.5,
  /** Its bark carries this far, metres (02 §9.1) - a shout, not an alarm. */
  barkNoise: 25,
  /** Seconds between barks while it has him, and while it mourns its handler. */
  barkEverySeconds: 1.2,
  /** At heel it keeps this near its handler, metres. */
  heelDistance: 1.5,
  /**
   * Casting, nose down: it sweeps points up to this far from where it lost the line (or from its handler, while he
   * searches), metres - two strides past a man's footprint either side - for this long before it gives up and goes
   * back to heel, seconds.
   */
  castRadius: 6,
  castSeconds: 20,
  /** One hit of anything kills it. */
  hp: 1,
  /** How big a body it is, metres: for the knife, the aim and collisions. */
  radius: 0.35,
} as const;
